import React from "react";

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    // for testing purpose
    // actions.echoHandler(message);
    if (message.length >= 2) {
      actions.validInputNlpJSHandler(message);
    } else {
      actions.invalidInputHandler();
    }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
